import WResultsClinicalGenetics from './WResultsClinicalGenetics'

export default WResultsClinicalGenetics
